/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Pack_TitleInputs */

const en_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited-Time Bundle`)
};

const ar_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزمة لفترة محدودة`)
};

const de_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitlich begrenztes Paket`)
};

const es_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquete por tiempo limitado`)
};

const fr_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack à durée limitée`)
};

const it_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacchetto a tempo limitato`)
};

const ja_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期間限定パック`)
};

const ko_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기간 한정 패키지`)
};

const pt_br_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacote por tempo limitado`)
};

const ru_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Набор на ограниченное время`)
};

const th_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็กเกจจำกัดเวลา`)
};

const tr_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sınırlı süreli paket`)
};

const zh_cn_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限时礼包`)
};

const zh_tw_starter_pack_title = /** @type {(inputs: Starter_Pack_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限時禮包`)
};

/**
* | output |
* | --- |
* | "Limited-Time Bundle" |
*
* @param {Starter_Pack_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_pack_title = /** @type {((inputs?: Starter_Pack_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Pack_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_pack_title(inputs)
	if (locale === "ar") return ar_starter_pack_title(inputs)
	if (locale === "de") return de_starter_pack_title(inputs)
	if (locale === "es") return es_starter_pack_title(inputs)
	if (locale === "fr") return fr_starter_pack_title(inputs)
	if (locale === "it") return it_starter_pack_title(inputs)
	if (locale === "ja") return ja_starter_pack_title(inputs)
	if (locale === "ko") return ko_starter_pack_title(inputs)
	if (locale === "pt_br") return pt_br_starter_pack_title(inputs)
	if (locale === "ru") return ru_starter_pack_title(inputs)
	if (locale === "th") return th_starter_pack_title(inputs)
	if (locale === "tr") return tr_starter_pack_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_pack_title(inputs)
	return zh_tw_starter_pack_title(inputs)
});